import { render, staticRenderFns } from "./ReactionInputField.vue?vue&type=template&id=129e630a&scoped=true&lang=pug&"
import script from "./ReactionInputField.vue?vue&type=script&lang=js&"
export * from "./ReactionInputField.vue?vue&type=script&lang=js&"
import style0 from "./ReactionInputField.vue?vue&type=style&index=0&id=129e630a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e630a",
  null
  
)

/* custom blocks */
import block0 from "./ReactionInputField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports